import React from 'react';
import appSty from './App.module.scss';

const App: React.FC = () => {
    return (
        <div className={appSty.App}>
            <h4>湖州市民通用户服务协议</h4>
                <p> &emsp;&emsp;<b>湖州市大数据发展管理局</b> (以下简称“大数据管理局”)依据本协议的规定为湖
                        州市民通App的用户（以下简称App用户）提供服务（以下简称“服务”）。为
                        使用湖州市民通软件（以下简称“本软件”）及服务，您应当阅读并遵守《湖州
                        市民通用户服务协议》（以下简称“本协议”），以及《湖州市民通用户信息保
                        护协议》内容中规定的所有权利和限制。请您务必审慎阅读、充分理解各条款内
                        容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议，并
                        选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。</p>
                <p>&emsp;&emsp;
                        如您已阅读并接受本协议所有条款，则您可以使用本软件及相关服务。您的注册、
                        使用、获取湖州市民通帐号、登录等行为即视为您已阅读并同意上述协议的约束。

                </p>
                <p>&emsp;&emsp;
                        如果您未满18周岁，请在法定监护人的陪同下阅读本协议及其他上述协议，
                        特别注意未成年人使用条款。

                </p>
            <h5>一、协议范围</h5>
               <p>&emsp;&emsp;1.1本协议是您与大数据管理局之间关于您下载、安装、使用本软件，以及使用大数据管理局相关服务所订立的协议。
               </p>
                <p>&emsp;&emsp;
                        1.2本协议内容同时包括大数据管理局可能不断发布的关于本服务的相关协议、业务规则等内容。大数据管理局将通过“湖州市民通App”公布最新的变更
                        或修改，不再向个人用户作个别通知。上述内容一经正式发布，即为本协议不可
                        分割的组成部分，如果您不同意大数据管理局对本服务所作的修改，您有权停止
                        使用“服务”。您使用或继续使用“服务”即表示您已阅读并接受经修订的协议。
                        当您与“湖州市民通APP”发生争议时，应以最新的条款为准。除另行明确声明
                        外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。

                </p>
                  <h5>二、关于本服务</h5>
                <p>&emsp;&emsp;
                        2.1本软件服务内容是指大数据管理中心向用户提供的湖州市民通APP，具体
                        服务内容主要包括：交通出行、生活服务、金融服务、医疗服务等。具体详情以
                        湖州市民通当时提供的服务内容为准。
                </p>
                <p>&emsp;&emsp;
                        2.2您使用本服务需要下载湖州市民通客户端软件。对于这个软件，大数据管
                        理局给予您一项个人的、不可转让及非排他性的许可，您可以在单一台终端设备
                        上安装、使用、显示、运行本软件。您仅可为访问或为本服务的目的而使用这些
                        软件及服务。
                </p>
                <p>&emsp;&emsp;
                        2.3本服务中湖州市民通客户端软件提供包括但不限于iOS、Android等多个应
                        用版本，用户必须选择与所安装终端设备相匹配的软件版本。

                </p>
                <p>&emsp;&emsp;
                        2.4您可以为使用本软件及服务的目的复制本软件的一个副本，仅用作备份。
                        备份副本必须包含原软件中含有的所有著作权信息。
                </p>
                <p>&emsp;&emsp;
                        2.5本条及本协议其他条款未明示授权的其他一切权利仍由大数据管理局保
                        留，您在行使这些权利时须另外取得大数据管理局的书面许可。大数据管理局如
                        果未行使前述任何权利，并不构成对该权利的放弃。
                </p>

                <h5>三、服务变更、中断或终止</h5>
                <p>&emsp;&emsp;
                        3.1鉴于网络服务的特殊性（包括但不限于服务器的稳定性、恶意的网络攻击
                        等行为及其他大数据管理中心无法控制的情形），用户同意大数据管理局有权随
                        时中断或终止部分或全部的服务（包括收费网络服务），若发生该等中断或中止
                        服务的情形，大数据管理局将尽可能及时通过网页公告、系统通知、私信、短信
                        提醒或其他合理方式通知受到影响的用户。如中断或终止的服务属于收费服务，
                        大数据管理局将向用户退回收取的服务费用或向受影响的用户提供等值的替代
                        性的收费网络服务。
                </p>
                <p>&emsp;&emsp;
                        3.2用户理解并认可，大数据管理局需要定期或不定期地对服务平台或相关的
                        设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，大数
                        据管理局无需为此承担任何责任，但大数据管理局应尽可能事先进行通告。
                </p>
                <p>&emsp;&emsp;
                        3.3如发生下列任何一种情形，大数据管理局有权随时中断或终止向用户提供
                        服务（包括收费服务）而无需对用户或任何第三方承担任何责任：
                </p>
                <p>&emsp;&emsp;
                        3.3.1违反了此协议或已在约定范围内的任一条款；
                </p>
                <p>&emsp;&emsp;
                        3.3.2根据此协议相关说明而终止服务；
                </p>
                <p>&emsp;&emsp;
                        3.3.3本协议终止或更新时，明示不愿接受新的服务协议的；
                </p>
                <p>&emsp;&emsp;
                        3.3.4无法核实或鉴定您向大数据管理局供的任何资料；
                </p>
                <p>&emsp;&emsp;
                        3.3.5其它任何违反互联网相关法律法规的信息或湖州市民通平台认为需终止
                        服务的情况。
                </p>
                <p>&emsp;&emsp;
                        服务终止后，湖州市民通平台没有义务为用户保留原帐号中或与之相关的信息，
                        或转发未曾阅读或发送的信息给用户或第三方。无论因任何原因以任何方式终止
                        服务，湖州市民通平台仍有权：<br/>
                        （1）保存或不保存该用户的注册数据及以前的交易行为记录； <br/>
                        （2）对于用户在服务终止前实施的违法或违约行为，湖州市民通平台保留追
                        索。此外，您同意，湖州市民通平台不会就终止您接入“服务”而对您或任何第
                        三者承担任何责任。
                </p>
                <p>&emsp;&emsp;
                        3.4用户如在申请开通湖州市民通服务后在任何连续90日内未实际使用，则大
                        数据管理局有权选择采取以下任何一种方式进行处理，由此产生的损失由用户自
                        行承担：
                </p>
                <p>&emsp;&emsp;
                        3.4.1回收用户昵称；
                </p>
                <p>&emsp;&emsp;
                        3.4.2停止为该用户提供服务。
                </p>
                <p>&emsp;&emsp;

                </p>

            <h5>四、软件的获取、安装、卸载与更新</h5>
            <p>&emsp;&emsp;4.1 您可以直接从大数据管理中心的网站上获取本软件，也可以从得到大数据管理局授权的第三方获取。</p>
            <p>&emsp;&emsp;4.2 如果您从未经大数据管理局授权的第三方获取本软件或与本软件名称相同的安装程序，大数据管理局无法保证该软件能够正常使用，也不能保证避免您在使用过程中发生任何的财产、隐私或其他安全问题，并对因此给您造成的损失不承担任何责任。</p>
            <p>&emsp;&emsp;4.3 大数据管理局可能为不同的终端设备开发了不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。</p>
            <p>&emsp;&emsp;4.4 下载安装程序后，您需要按照该程序提示的步骤正确安装。</p>
            <p>&emsp;&emsp;4.5 为提供更加优质、安全的服务，在本软件安装时大数据管理局可能推荐您安装其他软件，您可以选择安装或不安装。
            </p><p>&emsp;&emsp;4.6 大数据管理局有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。届时，您需要重新下载软件新版本或更新本软件后方可使用更新后的软件及相关服务。</p>
            <p>&emsp;&emsp;4.7 本软件新版本发布后，旧版本的软件可能无法使用。大数据管理局不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本。</p>


            <h5>五、用户使用规范</h5>
            <p>&emsp;&emsp;5.1 您在使用本服务前需要注册一个湖州市民通帐号。申请注册人不得赠与、借用、租用、转让或售卖湖州市民通帐号或者以其他方式许可他人使用湖州市民通帐号。否则由此产生的一切后果由用户自行承担。</p>
            <p>&emsp;&emsp;5.2 用户有责任妥善保管注册帐户信息及帐户密码的安全，用户需要对注册帐户以及密码下的行为承担法律责任。用户同意在任何情况下不向他人透露帐户及密码信息。非因大数据管理局原因导致的密码及帐号泄露，给用户或其他第三方造成损失的，大数据管理局不承担法律后果。</p>
            <p>&emsp;&emsp;5.3您理解并同意：大数据管理局在提供服务过程中可能会以各种方式投放各
                    种商业性广告或其他任何类型的商业信息；并且，用户同意接受大数据管理局通
                    过电子邮件、手机短信或其他方式向用户发送商品促销或其他相关商业信息。大
                    数据管理局向用户提供的各种信息及资料仅为参考，用户应依其独立判断做出
                    决策。用户据此进行交易的，产生的风险由用户自行承担，用户无权据此向大
                    数据管理局提出任何法律主张。在交易过程中，用户之间发生的纠纷，由纠纷
                    各方自行解决，大数据管理局不承担任何责任。</p>
            <p>&emsp;&emsp;5.4 用户在使用市民通服务过程中，必须遵循以下原则：</p>
            <p>&emsp;&emsp;5.4.1 不得违反中华人民共和国法律法规及相关国际条约或规则；</p>
            <p>&emsp;&emsp;5.4.2 不得违反与网络服务、本软件服务有关的网络协议、规定、程序及行业规则；
            </p>
            <p>&emsp;&emsp;5.4.3 不得违反法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求；</p>
            <p>&emsp;&emsp;5.4.4 不得进行任何可能对互联网或移动网正常运转造成不利影响的行为；</p>
            <p>&emsp;&emsp;5.4.5 不得上传、展示或传播任何不实虚假、冒充性的、骚扰性的、中伤性的、攻击性的、辱骂性的、恐吓性的、种族歧视性的、诽谤诋毁、泄露隐私、成人情色、恶意抄袭的或其他任何非法的信息资料；
            </p>
            <p>&emsp;&emsp;5.4.6 不得以任何方式侵犯其他任何人依法享有的专利权、著作权、商标权等知识产权，或姓名权、名称权、名誉权、荣誉权、肖像权、隐私权等人身权益，或其他任何合法权益；</p>
            <p>&emsp;&emsp;5.4.7 不得以任何形式侵犯大数据管理局的权利、利益或作出任何不利于大数据管理局的行为；</p>
            <p>&emsp;&emsp;5.4.8 不得从事其他任何影响本软件服务平台正常运营、破坏平台经营模式或其他有害平台生态的行为；
            </p>
            <p>&emsp;&emsp;5.4.9 不得为其他任何非法目的而使用本服务；</p>
            <p>&emsp;&emsp;5.4.10 法律法规、国家政策及本协议禁止的其他行为等。</p>
            <p>&emsp;&emsp;5.5您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。大数据管理局无法且不会对因前述风险而导致的任何损失或损害承担责任。
            </p>

            <h5>六、用户个人信息保护</h5>
            <p>&emsp;&emsp;6.1 保护用户个人信息是大数据管理局的一项基本原则，大数据管理局将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可大数据管理局不会向第三方公开、透露用户个人信息。</p>
            <p>&emsp;&emsp;6.2 您在注册帐号或使用本服务的过程中，需要提供一些必要的信息，例如：为向您提供帐号注册服务或进行用户身份识别，需要您填写手机号码；使用软件部分功能或相关服务时需要您同意获取使用您所在的地理位置信息。若国家法律法规或政策有特殊规定的，您需要提供真实的身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
            <p>&emsp;&emsp;6.3 一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。
            </p>
            <p>&emsp;&emsp;6.4 大数据管理局将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。
            </p>
            <p>&emsp;&emsp;6.5 未经您的同意，大数据管理局不会向公司以外的任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。</p>
            <p>&emsp;&emsp;6.6大数据管理局非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用大数据管理局的服务前，应事先取得您家长或法定监护人的同
                    意。若您在本软件上注册账号或者使用湖州市民通App服务，则视为已得到前述同意。</p>
            <p>&emsp;&emsp;6.7 同时，您接受本协议后，即表示您授权大数据管理局在符合以下条件之一的情况下可以对您提供的个人资料进行合理之利用：</p>
            <p>&emsp;&emsp;6.7.1 为免除您在生命、身体或财产方面之急迫危险；</p>
            <p>&emsp;&emsp;6.7.2 为防止他人权益之重大危害；</p>
            <p>&emsp;&emsp;6.7.3 为增进公共利益，且无害于您的重大利益；</p>
            <p>&emsp;&emsp;6.7.4 大数据管理局进行合理的数据分析或为了合理之商业目的对您提供的个人信息进行收集、整理或使用；</p>
            <p>&emsp;&emsp;6.7.5 大数据管理局可能通过本软件收集用户使用本软件的行为数据或与第三方在本网站投放的广告有关的数据。第三方公司的数据收集、使用行为将遵守国家有关法律法规的规定以及第三方公司对用户隐私和数据保护的规定。</p>
            <h5>七、第三方产品和服务</h5>
            <p>&emsp;&emsp;7.1因用户使用本软件或要求大数据管理局提供特定服务时，本软件可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供（包括但不限于第三方通过微信公众帐号提供的服务，或通过开放平台接入的内容等）。</p>
            <p>&emsp;&emsp;7.2您理解并同意，大数据管理局有权决定将本软件作商业用途，包括但不限于开发、使用本软件的部分服务为第三方作推广等，大数据管理局承诺在推广过程中严格按照本协议约定保护您的个人信息，同时您亦可以根据系统设置选择屏蔽、拒绝接收相关推广信息。</p>
            <p>&emsp;&emsp;7.3本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</p>
            <p>&emsp;&emsp;7.4本软件如果使用了第三方的软件或技术，大数据管理局将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包、或通过开源软件页面等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议、其他文件及网页，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求大数据管理局给予协助，您应当自行承担法律责任。</p>
            <p>&emsp;&emsp;7.5如因本软件使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，大数据管理局可协调处理。[同上。][略作修改，大数据管理局承担协调辅助作用]大数据管理局不对第三方软件或技术提供客服支持，若您需要获取支持，请与第三方联系。</p>



            <h5>八、免责声明</h5>
            <p>&emsp;&emsp;8.1 用户在使用本服务的过程中应遵守国家法律法规及政策规定，因其使用本服务而产生的行为后果由用户自行承担。</p>
            <p>&emsp;&emsp;8.1 本软件中外部链接指向的互联网内容或相关服务非大数据管理中心实际控制的，因此大数据管理局无法保证为向用户提供便利而设置的外部链接的准确性和完整性。用户通过外部链接获得的互联网内容或相关服务过程中，用户受其与互联网内容或相关服务提供方所签署的协议的约束，大数据管理局不就用户的前述行为承担任何责任。</p>
            <p>&emsp;&emsp;8.3 对于因不可抗力或大数据管理局不能控制的原因造成的服务中断或其它缺陷，大数据管理局不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。包括天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况；</p>
            <p>&emsp;&emsp;8.4 用户同意，对于大数据管理局向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，大数据管理局无需承担任何责任：</p>
            <p>&emsp;&emsp;8.4.1 大数据管理局向用户免费提供的服务；</p>
            <p>&emsp;&emsp;8.4.2 大数据管理局向用户赠送的任何产品或者服务；</p>
            <p>&emsp;&emsp;8.4.3 大数据管理局向收费服务用户附赠的各种产品或者服务。</p>
            <p>&emsp;&emsp;8.5 大数据管理局不对您在本软件及服务中相关数据的删除或储存失败负责；</p>
            <p>&emsp;&emsp;8.6 如果您停止使用本软件及服务或服务被终止或取消，大数据管理局可以从服务器上永久地删除您的数据。服务停止、终止或取消后，大数据管理局没有义务向您返还任何数据。</p>
            <p>&emsp;&emsp;8.7 由于软件与终端设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；</p>
            <p>&emsp;&emsp;8.8 用户在使用本软件访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；</p>
                <p>&emsp;&emsp;
                        8.9虽然我们已经采取现有的技术来保护您的个人信息，但是出现下列情形之一
                        的，我们将对您个人信息的泄露不承担责任：
                </p><p>&emsp;&emsp;
                8.9.1因您向第三方泄露等原因导致个人信息被公开的；
        </p><p>&emsp;&emsp;
                8.9.2由于黑客的入侵、计算机病毒的侵入、因政府管制等等不可抗力导致您的
                个人信息被公开的；
        </p><p>&emsp;&emsp;
                8.9.3按照公安、法院等有权机构的要求，需要公开您的个人信息的；
        </p><p>&emsp;&emsp;
                8.9.4湖州市民通依据本规则共享您的个人信息而公开的；
        </p>
                <p>&emsp;&emsp;
                        8.9.5其他非因湖州市民通的原因导致您的个人信息被公开的。
                </p>
            <h5>九、知识产权声明</h5>
            <p>&emsp;&emsp;9.1 大数据管理局是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，大数据管理局享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。</p>
            <p>&emsp;&emsp;9.2 未经大数据管理局或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</p>
            <h5>十、终端安全责任</h5>
            <p>&emsp;&emsp;10.1 您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。</p>
            <p>&emsp;&emsp;10.2 您不得制作、发布、使用、传播用于窃取湖州市民通帐号及他人个人信息、财产的恶意程序。</p>
            <p>&emsp;&emsp;10.3 维护软件安全与正常使用是大数据管理局和您的共同责任，大数据管理局将按照行业标准合理审慎地采取必要技术措施保护您的终端设备信息和数据安全，但是您承认和同意大数据管理局并不能就此提供完全保证。</p>
            <p>&emsp;&emsp;10.4 在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意大数据管理局有关防范诈骗犯罪的提示。</p>
            <h5>十一、其他</h5>
            <p>&emsp;&emsp;11.1 您使用本软件即视为您已阅读并同意受本协议的约束。大数据管理局有权在必要时修改本协议条款，且不再另行向您通知。您可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本软件，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本软件。
            </p>
            <p>&emsp;&emsp;11.2 本协议签订地为中华人民共和国浙江省湖州市吴兴区。</p>
            <p>&emsp;&emsp;11.3 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
            <p>&emsp;&emsp;11.4 若您和大数据管理局之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交大数据管理局所在地管辖权的人民法院管辖。</p>
            <p>&emsp;&emsp;11.5 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
            <p>&emsp;&emsp;11.6 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
                <h5>
                        联系我们
                </h5>
<p>&emsp;&emsp;
        如您对本规则存在任何疑问，或任何相关的投诉、意见，请联系湖州市民通客户
        服务热线0572-2555559。

</p>
        </div>
    );
}

export default App;
